import { Flex, Spin } from "antd";
import { LoadingOutlined } from '@ant-design/icons';


export default (props: { width: number, height: number, progress?: number, backgroundColor?: string, progressColor?: string, borderRadius?: number, label?: string }) => {

    const { 
        width, 
        height, 
        progress = 0, 
        backgroundColor = '#EAECF0', 
        progressColor = '#F79009', 
        borderRadius = 4,
        label = ''
     } = props;

        // 确保进度在 0-100 之间
    const normalizedProgress = Math.min(Math.max(progress, 0), 100);
    // 计算进度条宽度
    const progressWidth = (normalizedProgress / 100) * width;

    return (
        <Flex vertical>
            <Flex align="center" gap={4}>
                <div style={{fontSize: 14, fontWeight: 500, color: progressColor}}>{label}</div>
                {
                    normalizedProgress == 0 &&
                    <Spin indicator={<LoadingOutlined spin />} size="small" style={{color: progressColor}} />
                }
                
            </Flex>
            
            <Flex align="center" gap={12}>
                <div style={{ 
                    width: `${width}px`, 
                    height: `${height}px`, 
                    position: 'relative', 
                    borderRadius: `${borderRadius}px`
                    }}>
                    {/* 背景条 */}
                    <div style={{
                        width: `${width}px`,
                        height: `${height}px`,
                        position: 'absolute',
                        background: backgroundColor,
                        borderRadius: `${borderRadius}px`
                    }} />
                    {/* 进度条 */}
                    <div style={{
                        width: `${progressWidth}px`,
                        height: `${height}px`,
                        position: 'absolute',
                        background: progressColor,
                        borderRadius: `${borderRadius}px`
                    }} />
                </div>
                <div style={{
                    fontSize: 14,
                    fontWeight: 500,
                    color: '#344054',
                }}>{`${normalizedProgress}%`}</div>    
                
            </Flex>
        </Flex>
        
    );
}